import { Routes, Route } from "react-router-dom";
import SuperAdminLayout from "./SuperAdminLayout";
import SuperAdminDashboard from "../Pages/SuperAdminDashboard";
import SuperAdminCountry from "../Pages/SuperAdminCountry";
import SuperAdminInstitute from "../Pages/SuperAdminInstitute";
import AddCountry from "../Pages/SubPages/AddCountry";
import AddInstitute from "../Pages/SubPages/AddInstitute";
import SuperAdminBranch from "../Pages/SuperAdminBranch";
import AddBranchOffice from "../Pages/SubPages/AddBranchOffice";
import SuperAdminChancler from "../Pages/SuperAdminChancler";
import AddCounceller from "../Pages/SubPages/AddCounceller";
import AssignInstituteC from "../Pages/SubPages/AssignInstituteC";
import SuperAdminFrontOffice from "../Pages/SuperAdminFrontOffice";
import AddFrontOffice from "../Pages/SubPages/AddFrontOffice";
import SuperAdminApplication from "../Pages/SuperAdminApplication";
import Addapplication from "../Pages/SubPages/Addapplication";
import ErrorPage from "../ErrorPage";
import SingleCountry from "../Pages/SubPages/SingleCountry";
import EditCountry from "../Pages/SubPages/EditCountry";
import SingleInstitute from "../Pages/SubPages/SingleInstitute";
import EditInstitute from "../Pages/SubPages/EditInstitute";
import SingleFrontOffice from "../Pages/SubPages/SingleFrontOffice";
import EditFrontOffice from "../Pages/SubPages/EditFrontOffice";
import SuperAdminCourse from "../Pages/SuperAdminCourse";


const SuperAdminRoutes = () => {
  return (
    <SuperAdminLayout>
      <Routes>
         <Route path="dashboard" element={<SuperAdminDashboard/>} />
         <Route path="country" element={<SuperAdminCountry/>} />
          <Route path="add-country" element={<AddCountry/>} />
            <Route path="single-country/:id" element={<SingleCountry/>} />
              <Route path="edit-country/:id" element={<EditCountry/>} />
         <Route path="institute" element={<SuperAdminInstitute/>} />
         <Route path="add-institute" element={<AddInstitute/>} />
          <Route path="single-institute/:id" element={<SingleInstitute/>} />
              <Route path="edit-institute/:id" element={<EditInstitute/>} />
          <Route path="branch-office/view" element={<SuperAdminBranch/>} />
<Route path="branch-office/add" element={<AddBranchOffice/>} />
<Route path="counsellor" element={<SuperAdminChancler/>} />
<Route path="counsellor/add" element={<AddCounceller/>} />
<Route path="counsellor/assign-institute" element={<AssignInstituteC/>} />
<Route path="front-office/view" element={<SuperAdminFrontOffice/>} />
<Route path="front-office/add" element={<AddFrontOffice/>} />
<Route path="show-front-office/:id" element={<SingleFrontOffice/>} />
              <Route path="edit-front-office/:id" element={<EditFrontOffice/>} />
<Route path="/application-processor/view" element={<SuperAdminApplication/>} />
<Route path="/application-processor/add" element={<Addapplication/>} />
<Route path="/course" element={<SuperAdminCourse/>} />

<Route path="*" element={<ErrorPage />} />
        {/* Add more super admin pages here */}
      </Routes>
    </SuperAdminLayout>
  );
};

export default SuperAdminRoutes;
